export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8884.a46a3fe1.jpg";